var Oe = Object.defineProperty, Te = Object.defineProperties;
var De = Object.getOwnPropertyDescriptors;
var ie = Object.getOwnPropertySymbols;
var qe = Object.prototype.hasOwnProperty, Ie = Object.prototype.propertyIsEnumerable;
var ue = (h, v, p) => v in h ? Oe(h, v, { enumerable: !0, configurable: !0, writable: !0, value: p }) : h[v] = p, F = (h, v) => {
  for (var p in v || (v = {}))
    qe.call(v, p) && ue(h, p, v[p]);
  if (ie)
    for (var p of ie(v))
      Ie.call(v, p) && ue(h, p, v[p]);
  return h;
}, X = (h, v) => Te(h, De(v));
var j = (h, v, p) => new Promise((k, g) => {
  var y = (f) => {
    try {
      l(p.next(f));
    } catch (d) {
      g(d);
    }
  }, w = (f) => {
    try {
      l(p.throw(f));
    } catch (d) {
      g(d);
    }
  }, l = (f) => f.done ? k(f.value) : Promise.resolve(f.value).then(y, w);
  l((p = p.apply(h, v)).next());
});
import { m as I, r as ke, u as N, o as z, b as M, c as t, e as n, f as i, l as D, F as S, g as e, i as $, t as a, k as _, h as C, w as R, p as q, a as O, q as Se, v as T, x as re, y as $e, n as ae, z as de, A as ce, B as Re } from "./define-element-XpjsV6s1.js";
import { u as B } from "./use-user-CwEHAZOt.js";
import { u as se } from "./use-config-1FCHS5th.js";
import { u as we } from "./use-offering-D7hYyekH.js";
import { u as ne, a as Ae } from "./query-client-DZ5Df1It.js";
import { L as J } from "./Loader-CeIJU_1y.js";
import { B as H } from "./Button-D5lKR5Sd.js";
import { _ as E } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as Ne } from "./use-wishlist-DGdQdUnB.js";
import { f as Y } from "./format-currency-D_QngrXg.js";
import { L as ee } from "./Link-Ck5HVnu-.js";
import { T as fe, f as L, a as ze } from "./Tab-Bza7rjAG.js";
import { C as Ue, L as Pe, u as Me } from "./use-payment-CcwDaLQz.js";
import { I as W } from "./Input-yplyeePD.js";
import { P as Ce } from "./Phone-BBsTgKL1.js";
import { D as Ee } from "./DateOfBirth-C57dVBDY.js";
import { u as xe } from "./use-addresses-Wp77HwbF.js";
import { A as Ve } from "./Address-QnUa_uo4.js";
import { p as Fe, S as Ye, c as Le } from "./StripePaymentForm-CDVtd19T.js";
import { c as Be } from "./utils-CMsllPx8.js";
import { _ as He } from "./Icon-CGbhZCm-.js";
function le() {
  ne();
  const { isValidUser: h } = B(), v = Ae({
    queryKey: ["orders", h],
    queryFn: () => j(null, null, function* () {
      if (!h.value) return [];
      const k = yield ke("customer/orders");
      return !k || k.error ? [] : Array.isArray(k) ? k : Object.values(k);
    })
  }), p = I(() => v.data.value && v.data.value.length > 0);
  return X(F({}, v), {
    hasOrders: p
  });
}
const je = {
  ref: "container",
  class: "offset-account-home"
}, We = { class: "offset-account-home-recap" }, Qe = {
  key: 0,
  class: "offset-account-home-credits"
}, Ke = { class: "offset-account-home-feature" }, Ze = { class: "offset-account-pill" }, Ge = { class: "offset-account-home-row-title" }, Je = { class: "offset-account-home-row-title" }, Xe = { key: 2 }, et = {
  __name: "AccountHome",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  emits: ["navigate"],
  setup(h, { emit: v }) {
    const p = h, k = v, { isPending: g, data: y, isValidUser: w } = B(), { config: l } = se(), { isPending: f, offeringProducts: d } = we(), { data: m } = le(), o = I(() => d.value.length > 0), c = I(() => d.value.reduce((P, V) => P + (V.quantity || 0), 0)), r = I(() => (m.value || []).filter((P) => P.ship_status === "Shipped")), s = I(() => {
      var P;
      return (P = y.value) != null && P.created ? y.value.created.slice(0, 4) : null;
    }), u = N("container");
    return z(() => {
      M(u.value, p.inheritStyle);
    }), (P, V) => {
      var K, Z;
      return t(), n("div", je, [
        i(g) ? (t(), D(J, { key: 0 })) : i(w) ? (t(), n(S, { key: 1 }, [
          e("p", We, [
            $(a(i(y).first_name), 1),
            s.value ? (t(), n(S, { key: 0 }, [
              $(", you've been with us since " + a(s.value), 1)
            ], 64)) : _("", !0),
            V[3] || (V[3] = $(". ", -1)),
            o.value ? (t(), n(S, { key: 1 }, [
              $(" Your current offer" + a(i(d).length === 1 ? "" : "s") + " include" + a(i(d).length === 1 ? "s" : "") + " " + a(c.value) + " bottle" + a(c.value === 1 ? "" : "s") + " across " + a(i(d).length) + " wine" + a(i(d).length === 1 ? "" : "s") + ". ", 1)
            ], 64)) : _("", !0)
          ]),
          i(y).credits > 0 ? (t(), n("div", Qe, [
            e("p", null, [
              V[4] || (V[4] = $(" You have ", -1)),
              e("strong", null, "$" + a(i(y).credits), 1),
              V[5] || (V[5] = $(" in credits, applied automatically to your next order. ", -1))
            ])
          ])) : _("", !0),
          !i(f) && o.value ? (t(), n(S, { key: 1 }, [
            V[9] || (V[9] = e("div", { class: "offset-account-eyebrow" }, "Open to You Now", -1)),
            e("div", Ke, [
              V[7] || (V[7] = e("span", { class: "offset-account-pill is-filled" }, "Allocation Release", -1)),
              V[8] || (V[8] = e("h3", null, "Your Allocation", -1)),
              e("p", null, a(c.value) + " bottle" + a(c.value === 1 ? "" : "s") + " across " + a(i(d).length) + " wine" + a(i(d).length === 1 ? "" : "s") + " are available to you now. ", 1),
              C(H, {
                class: "offset-account-cta",
                onClick: V[0] || (V[0] = (Q) => k("navigate", "offers"))
              }, {
                default: R(() => V[6] || (V[6] = [
                  $(" View Your Offers ", -1)
                ])),
                _: 1,
                __: [6]
              })
            ])
          ], 64)) : _("", !0),
          (Z = (K = i(y)) == null ? void 0 : K.clubs) != null && Z.length ? (t(), n("div", {
            key: 2,
            class: "offset-account-home-row",
            onClick: V[1] || (V[1] = (Q) => k("navigate", "membership"))
          }, [
            e("span", Ze, a(i(l).club_title || "Membership"), 1),
            e("span", Ge, a(i(y).clubs.map((Q) => Q.name).join(", ")), 1)
          ])) : _("", !0),
          r.value.length ? (t(), n("div", {
            key: 3,
            class: "offset-account-home-row",
            onClick: V[2] || (V[2] = (Q) => k("navigate", "wines"))
          }, [
            V[10] || (V[10] = e("span", { class: "offset-account-pill" }, "In Flight", -1)),
            e("span", Je, a(r.value.length) + " order" + a(r.value.length === 1 ? "" : "s") + " in transit ", 1)
          ])) : _("", !0)
        ], 64)) : (t(), n("p", Xe, "Please log in to view your account."))
      ], 512);
    };
  }
}, tt = /* @__PURE__ */ E(et, [["__scopeId", "data-v-3c98284a"]]), st = {
  ref: "container",
  class: "offset-account-offers"
}, nt = { key: 1 }, at = {
  key: 0,
  class: "offset-account-offers-subtitle"
}, lt = {
  key: 1,
  class: "offset-account-offers-subtitle"
}, ot = {
  key: 2,
  class: "offset-account-offer"
}, it = { class: "offset-account-offer-body" }, ut = { class: "offset-account-offer-list" }, rt = {
  key: 3,
  class: "offset-account-offer"
}, dt = { class: "offset-account-offer-list" }, ct = {
  __name: "AccountOffers",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    offeringUrl: {
      type: String,
      default: "/offering"
    }
  },
  setup(h) {
    const v = h, { isPending: p, offeringProducts: k, authRequired: g } = we(), { wish: y, fetchWish: w } = Ne(), l = I(() => (k.value.length > 0 ? 1 : 0) + (Object.keys(y.value).length > 0 ? 1 : 0)), f = N("container");
    return z(() => {
      M(f.value, v.inheritStyle), w();
    }), (d, m) => (t(), n("div", st, [
      m[7] || (m[7] = e("h2", null, "Offers", -1)),
      i(p) ? (t(), D(J, { key: 0 })) : i(g) ? (t(), n("p", nt, "Please log in to view your offers.")) : (t(), n(S, { key: 2 }, [
        l.value > 0 ? (t(), n("p", at, a(l.value) + " offer" + a(l.value === 1 ? "" : "s") + " currently available to you. ", 1)) : (t(), n("p", lt, "You don't have any offers available right now.")),
        m[6] || (m[6] = e("hr", { class: "offset-account-rule" }, null, -1)),
        i(k).length ? (t(), n("section", ot, [
          m[1] || (m[1] = e("div", { class: "offset-account-offer-meta" }, [
            e("span", { class: "offset-account-pill is-filled" }, "Allocation Release")
          ], -1)),
          m[2] || (m[2] = e("h3", null, "Your Allocation", -1)),
          e("p", it, a(i(k).length) + " wine" + a(i(k).length === 1 ? "" : "s") + " " + a(i(k).length === 1 ? "is" : "are") + " waiting for your review. ", 1),
          e("ul", ut, [
            (t(!0), n(S, null, q(i(k), (o) => (t(), n("li", {
              key: o.sku
            }, [
              e("span", null, a(o.name || o.label), 1),
              e("span", null, a(i(Y)(o.price)), 1)
            ]))), 128))
          ]),
          C(ee, {
            href: h.offeringUrl,
            class: "offset-account-cta-link"
          }, {
            default: R(() => m[0] || (m[0] = [
              $("Review Your Allocation", -1)
            ])),
            _: 1,
            __: [0]
          }, 8, ["href"])
        ])) : _("", !0),
        Object.keys(i(y)).length ? (t(), n("section", rt, [
          m[4] || (m[4] = e("div", { class: "offset-account-offer-meta" }, [
            e("span", { class: "offset-account-pill" }, "Standing Offer")
          ], -1)),
          m[5] || (m[5] = e("h3", null, "Standing Offer", -1)),
          e("ul", dt, [
            (t(!0), n(S, null, q(i(y), (o) => (t(), n("li", {
              key: o.sku
            }, [
              e("span", null, a(o.description || o.sku), 1),
              e("span", null, a(o.quantity) + " on standing order", 1)
            ]))), 128))
          ]),
          C(ee, {
            href: h.offeringUrl,
            class: "offset-account-cta-link"
          }, {
            default: R(() => m[3] || (m[3] = [
              $("Manage Standing Offer", -1)
            ])),
            _: 1,
            __: [3]
          }, 8, ["href"])
        ])) : _("", !0)
      ], 64))
    ], 512));
  }
}, ft = /* @__PURE__ */ E(ct, [["__scopeId", "data-v-71436da0"]]), vt = {
  ref: "container",
  class: "offset-account-wines"
}, pt = { key: 0 }, yt = { class: "offset-account-wines-list" }, mt = { class: "offset-account-wines-row-title" }, _t = {
  key: 0,
  class: "offset-account-shipment-group"
}, gt = { class: "offset-account-shipment-title" }, ht = { class: "offset-account-shipment-meta" }, bt = {
  key: 1,
  class: "offset-account-shipment-group"
}, kt = { class: "offset-account-shipment-checkbox" }, St = { class: "offset-account-shipment-title" }, $t = { class: "offset-account-shipment-meta" }, wt = { class: "offset-account-shipment-combine" }, At = {
  key: 2,
  class: "offset-account-shipment-group"
}, Ut = { class: "offset-account-shipment-title" }, Pt = { class: "offset-account-shipment-meta" }, Ct = {
  key: 3,
  class: "offset-account-shipment-group"
}, xt = { class: "offset-account-shipment-title" }, Vt = { class: "offset-account-shipment-meta" }, Ot = {
  __name: "AccountWines",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, { data: p, isPending: k, hasOrders: g } = le(), y = I(() => {
      const r = {};
      for (const s of p.value || [])
        for (const u of s.products || []) {
          const P = u.sku;
          r[P] || (r[P] = {
            sku: u.sku,
            name: u.description || u.name,
            quantity: 0
          }), r[P].quantity += parseInt(u.quantity, 10) || 0;
        }
      return Object.values(r);
    });
    function w(r) {
      return (r.shipping_method_name || "").toLowerCase().includes("pickup");
    }
    const l = I(() => (p.value || []).filter(
      (r) => r.ship_status === "Shipped" && !w(r)
    )), f = I(() => (p.value || []).filter(
      (r) => r.ship_status === "Pending" && !w(r)
    )), d = I(() => (p.value || []).filter(
      (r) => w(r) && r.ship_status !== "Delivered"
    )), m = I(() => (p.value || []).filter((r) => r.ship_status === "Delivered")), o = O([]), c = N("container");
    return z(() => {
      M(c.value, v.inheritStyle);
    }), (r, s) => (t(), n("div", vt, [
      s[9] || (s[9] = e("h2", null, "Your Wines", -1)),
      i(k) ? (t(), D(J, { key: 0 })) : (t(), n(S, { key: 1 }, [
        i(g) ? (t(), D(ze, { key: 1 }, {
          default: R(() => [
            C(fe, { title: "Cellar" }, {
              default: R(() => [
                e("div", yt, [
                  (t(!0), n(S, null, q(y.value, (u) => (t(), n("div", {
                    key: u.sku,
                    class: "offset-account-wines-row"
                  }, [
                    e("span", mt, a(u.name), 1),
                    e("span", null, a(u.quantity) + " bottle" + a(u.quantity === 1 ? "" : "s") + " ordered", 1)
                  ]))), 128))
                ])
              ]),
              _: 1
            }),
            C(fe, { title: "Shipments" }, {
              default: R(() => [
                l.value.length ? (t(), n("div", _t, [
                  s[1] || (s[1] = e("div", { class: "offset-account-shipment-group-header" }, [
                    e("span", { class: "offset-account-eyebrow" }, "In Transit")
                  ], -1)),
                  (t(!0), n(S, null, q(l.value, (u) => {
                    var P;
                    return t(), n("div", {
                      key: u.id,
                      class: "offset-account-shipment-row"
                    }, [
                      e("div", null, [
                        s[0] || (s[0] = e("span", { class: "offset-account-status-dot is-active" }, "In Transit", -1)),
                        e("div", gt, "Order #" + a(u.id), 1),
                        e("div", ht, [
                          $(a(i(L)(u.datestamp)) + " ", 1),
                          (P = u.packages) != null && P.length ? (t(), n(S, { key: 0 }, [
                            $(" · Tracking " + a(u.packages.map((V) => V.TrackingNumber).join(", ")), 1)
                          ], 64)) : _("", !0)
                        ])
                      ])
                    ]);
                  }), 128))
                ])) : _("", !0),
                f.value.length ? (t(), n("div", bt, [
                  s[4] || (s[4] = e("div", { class: "offset-account-shipment-group-header" }, [
                    e("span", { class: "offset-account-eyebrow" }, "Open Orders")
                  ], -1)),
                  (t(!0), n(S, null, q(f.value, (u) => (t(), n("div", {
                    key: u.id,
                    class: "offset-account-shipment-row"
                  }, [
                    e("label", kt, [
                      C(Ue, {
                        modelValue: o.value.includes(u.id),
                        "onUpdate:modelValue": (P) => {
                          o.value = P ? [...o.value, u.id] : o.value.filter((V) => V !== u.id);
                        }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      e("div", null, [
                        e("div", St, "Order #" + a(u.id), 1),
                        e("div", $t, a(i(L)(u.datestamp)), 1)
                      ])
                    ])
                  ]))), 128)),
                  e("div", wt, [
                    s[3] || (s[3] = e("p", null, "Select two or more open orders to send them together in one delivery.", -1)),
                    C(H, {
                      variant: "alt",
                      disabled: "",
                      title: "Coming soon"
                    }, {
                      default: R(() => s[2] || (s[2] = [
                        $("Combine Into One Delivery", -1)
                      ])),
                      _: 1,
                      __: [2]
                    })
                  ])
                ])) : _("", !0),
                d.value.length ? (t(), n("div", At, [
                  s[7] || (s[7] = e("div", { class: "offset-account-shipment-group-header" }, [
                    e("span", { class: "offset-account-eyebrow" }, "Waiting for Collection")
                  ], -1)),
                  (t(!0), n(S, null, q(d.value, (u) => (t(), n("div", {
                    key: u.id,
                    class: "offset-account-shipment-row"
                  }, [
                    e("div", null, [
                      s[5] || (s[5] = e("span", { class: "offset-account-status-dot is-active" }, "Ready for Collection", -1)),
                      e("div", Ut, "Order #" + a(u.id), 1),
                      e("div", Pt, a(i(L)(u.datestamp)), 1)
                    ]),
                    C(H, {
                      disabled: "",
                      title: "Coming soon"
                    }, {
                      default: R(() => s[6] || (s[6] = [
                        $("Tell the Roadhouse", -1)
                      ])),
                      _: 1,
                      __: [6]
                    })
                  ]))), 128))
                ])) : _("", !0),
                m.value.length ? (t(), n("div", Ct, [
                  s[8] || (s[8] = e("div", { class: "offset-account-shipment-group-header" }, [
                    e("span", { class: "offset-account-eyebrow" }, "Delivered")
                  ], -1)),
                  (t(!0), n(S, null, q(m.value, (u) => (t(), n("div", {
                    key: u.id,
                    class: "offset-account-shipment-row"
                  }, [
                    e("div", null, [
                      e("div", xt, "Order #" + a(u.id), 1),
                      e("div", Vt, a(i(L)(u.datestamp)), 1)
                    ])
                  ]))), 128))
                ])) : _("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : (t(), n("p", pt, "You haven't ordered any wines yet."))
      ], 64))
    ], 512));
  }
}, Tt = /* @__PURE__ */ E(Ot, [["__scopeId", "data-v-1a0cbc6d"]]), Dt = {
  ref: "container",
  class: "offset-account-history"
}, qt = { class: "offset-account-eyebrow" }, It = { class: "offset-account-order-addresses" }, Rt = {
  key: 0,
  class: "offset-account-order-tracking"
}, Nt = { class: "offset-account-order-items" }, zt = { class: "text-right" }, Mt = { class: "offset-account-order-totals" }, Et = { class: "offset-account-order-total-row" }, Ft = {
  key: 0,
  class: "offset-account-order-total-row"
}, Yt = { class: "offset-account-order-total-row" }, Lt = { class: "offset-account-order-total-row" }, Bt = {
  key: 1,
  class: "offset-account-order-total-row"
}, Ht = {
  key: 2,
  class: "offset-account-order-total-row"
}, jt = { class: "offset-account-order-total-row is-total" }, Wt = {
  key: 1,
  class: "offset-account-order-payment-note"
}, Qt = ["href"], Kt = { key: 0 }, Zt = ["onClick"], Gt = { class: "offset-account-history-row-date" }, Jt = { class: "offset-account-history-row-title" }, Xt = { class: "offset-account-history-row-meta" }, es = {
  __name: "AccountHistory",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, { data: p, isPending: k, hasOrders: g } = le(), { data: y } = B(), w = O(null), l = I(() => (p.value || []).find((m) => m.id === w.value) || null);
    function f(m) {
      return (m.products || []).reduce((o, c) => o + (parseInt(c.quantity, 10) || 0), 0);
    }
    const d = N("container");
    return z(() => {
      M(d.value, v.inheritStyle);
    }), (m, o) => {
      var c, r;
      return t(), n("div", Dt, [
        i(k) ? (t(), D(J, { key: 0 })) : l.value ? (t(), n(S, { key: 1 }, [
          e("button", {
            type: "button",
            class: "offset-account-back",
            onClick: o[0] || (o[0] = (s) => w.value = null)
          }, " ← Your History "),
          e("span", qt, a(i(L)(l.value.datestamp)) + " · " + a(l.value.ship_status), 1),
          e("h2", null, "Order #" + a(l.value.id), 1),
          e("div", It, [
            e("div", null, [
              o[3] || (o[3] = e("strong", null, "Delivery Address", -1)),
              o[4] || (o[4] = e("br", null, null, -1)),
              $(" " + a(l.value.shipping_first_name) + " " + a(l.value.shipping_last_name), 1),
              o[5] || (o[5] = e("br", null, null, -1)),
              $(" " + a(l.value.shipping_address), 1),
              o[6] || (o[6] = e("br", null, null, -1)),
              l.value.shipping_address_2 ? (t(), n(S, { key: 0 }, [
                $(a(l.value.shipping_address_2), 1),
                o[1] || (o[1] = e("br", null, null, -1))
              ], 64)) : _("", !0),
              $(" " + a(l.value.shipping_city) + ", " + a(l.value.shipping_state) + " " + a(l.value.shipping_zip) + " ", 1),
              l.value.shipping_country && l.value.shipping_country !== "US" ? (t(), n(S, { key: 1 }, [
                o[2] || (o[2] = e("br", null, null, -1)),
                $(a(l.value.shipping_country), 1)
              ], 64)) : _("", !0)
            ]),
            e("div", null, [
              l.value.requested_ship_date ? (t(), n(S, { key: 0 }, [
                o[7] || (o[7] = e("strong", null, "Requested Ship Date", -1)),
                o[8] || (o[8] = e("br", null, null, -1)),
                $(" " + a(i(L)(l.value.requested_ship_date)), 1),
                o[9] || (o[9] = e("br", null, null, -1)),
                o[10] || (o[10] = e("br", null, null, -1))
              ], 64)) : _("", !0),
              l.value.shipping_method_name ? (t(), n(S, { key: 1 }, [
                o[11] || (o[11] = e("strong", null, "Fulfillment Method", -1)),
                o[12] || (o[12] = e("br", null, null, -1)),
                $(" " + a(l.value.shipping_method_name), 1)
              ], 64)) : _("", !0)
            ])
          ]),
          l.value.packages && l.value.packages.length ? (t(), n("div", Rt, [
            o[13] || (o[13] = e("strong", null, "Tracking", -1)),
            (t(!0), n(S, null, q(l.value.packages, (s) => (t(), n("div", {
              key: s.TrackingNumber
            }, a(s.TrackingNumber), 1))), 128))
          ])) : _("", !0),
          e("table", Nt, [
            o[15] || (o[15] = e("thead", null, [
              e("tr", null, [
                e("th", null, "Items"),
                e("th", null, "Qty"),
                e("th", { class: "text-right" }, "Subtotal")
              ])
            ], -1)),
            e("tbody", null, [
              (t(!0), n(S, null, q(l.value.products || [], (s) => (t(), n("tr", {
                key: s.sku
              }, [
                e("td", null, [
                  e("strong", null, a(s.description || s.name), 1),
                  o[14] || (o[14] = e("br", null, null, -1)),
                  e("small", null, a(i(Y)(s.price)) + " each", 1)
                ]),
                e("td", null, a(s.quantity), 1),
                e("td", zt, a(i(Y)(s.price * s.quantity)), 1)
              ]))), 128))
            ])
          ]),
          e("div", Mt, [
            e("div", Et, [
              o[16] || (o[16] = e("span", null, "Subtotal", -1)),
              e("span", null, a(i(Y)(l.value.subtotal)), 1)
            ]),
            l.value.discount > 0 ? (t(), n("div", Ft, [
              o[17] || (o[17] = e("span", null, "Discount", -1)),
              e("span", null, "(" + a(i(Y)(l.value.discount)) + ")", 1)
            ])) : _("", !0),
            e("div", Yt, [
              o[18] || (o[18] = e("span", null, "Tax", -1)),
              e("span", null, a(i(Y)(l.value.tax)), 1)
            ]),
            e("div", Lt, [
              o[19] || (o[19] = e("span", null, "Delivery", -1)),
              e("span", null, a(i(Y)(l.value.shipping)), 1)
            ]),
            l.value.shipping_insurance && l.value.shipping_insurance != "0.00" ? (t(), n("div", Bt, [
              o[20] || (o[20] = e("span", null, "Insurance", -1)),
              e("span", null, a(i(Y)(l.value.shipping_insurance)), 1)
            ])) : _("", !0),
            l.value.credits > 0 ? (t(), n("div", Ht, [
              o[21] || (o[21] = e("span", null, "Credits", -1)),
              e("span", null, "(" + a(i(Y)(l.value.credits)) + ")", 1)
            ])) : _("", !0),
            e("div", jt, [
              o[22] || (o[22] = e("strong", null, "Total", -1)),
              e("strong", null, a(i(Y)(l.value.total)), 1)
            ])
          ]),
          l.value.credit_type ? (t(), n("div", Wt, [
            e("small", null, " Charged to " + a(l.value.credit_type) + " ending in " + a(l.value.credit_number) + ". ", 1)
          ])) : _("", !0),
          e("a", {
            href: `/account/invoice/${l.value.id}/`,
            target: "_blank",
            class: "offset-account-order-invoice"
          }, " Print Receipt ", 8, Qt)
        ], 64)) : (t(), n(S, { key: 2 }, [
          o[24] || (o[24] = e("h2", null, "Your History", -1)),
          i(g) ? (t(), n(S, { key: 1 }, [
            e("p", null, "Thank you, " + a((r = i(y)) == null ? void 0 : r.first_name) + "!", 1),
            o[23] || (o[23] = e("hr", { class: "offset-account-rule" }, null, -1)),
            (t(!0), n(S, null, q(i(p), (s) => (t(), n("div", {
              key: s.id,
              class: "offset-account-history-row",
              onClick: (u) => w.value = s.id
            }, [
              e("span", Gt, a(i(L)(s.datestamp).slice(-4)), 1),
              e("span", Jt, " Order #" + a(s.id) + " — " + a(f(s)) + " bottle" + a(f(s) === 1 ? "" : "s"), 1),
              e("span", Xt, a(s.ship_status) + " · " + a(i(Y)(s.total)), 1)
            ], 8, Zt))), 128))
          ], 64)) : (t(), n("p", Kt, a((c = i(y)) == null ? void 0 : c.first_name) + ", it looks like you haven't made any purchases yet. ", 1))
        ], 64))
      ], 512);
    };
  }
}, ts = /* @__PURE__ */ E(es, [["__scopeId", "data-v-7c6b79ab"]]), ss = { ref: "container" }, ns = {
  key: 0,
  class: "offset-account-success",
  role: "status"
}, as = {
  key: 1,
  class: "offset-account-error",
  role: "alert"
}, ls = { class: "grouped" }, os = {
  __name: "AccountProfile",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, { data: p, isValidUser: k, updateProfile: g } = B(), y = ne(), w = O(!1), l = O(!1), f = O(null), d = O({
      first_name: "",
      last_name: "",
      phone: "",
      birthday: ""
    });
    Se(
      p,
      (c) => {
        c && (d.value.first_name = c.first_name || "", d.value.last_name = c.last_name || "", d.value.phone = c.phone || "", d.value.birthday = c.birthday || "");
      },
      { immediate: !0 }
    );
    function m() {
      return j(this, null, function* () {
        w.value = !0, l.value = !1, f.value = null;
        try {
          yield g(d.value), y == null || y.invalidateQueries({ queryKey: ["user"] }), l.value = !0;
        } catch (c) {
          f.value = c.message;
        } finally {
          w.value = !1;
        }
      });
    }
    const o = N("container");
    return z(() => {
      M(o.value, v.inheritStyle);
    }), (c, r) => (t(), n("div", ss, [
      r[4] || (r[4] = e("h2", null, "Account", -1)),
      r[5] || (r[5] = e("hr", { class: "offset-account-rule" }, null, -1)),
      l.value ? (t(), n("div", ns, "Profile updated successfully.")) : _("", !0),
      f.value ? (t(), n("div", as, a(f.value), 1)) : _("", !0),
      i(k) ? (t(), n(S, { key: 2 }, [
        e("div", ls, [
          C(W, {
            type: "text",
            label: "First Name",
            modelValue: d.value.first_name,
            "onUpdate:modelValue": r[0] || (r[0] = (s) => d.value.first_name = s),
            required: "",
            floating: !0
          }, null, 8, ["modelValue"]),
          C(W, {
            type: "text",
            label: "Last Name",
            modelValue: d.value.last_name,
            "onUpdate:modelValue": r[1] || (r[1] = (s) => d.value.last_name = s),
            required: "",
            floating: !0
          }, null, 8, ["modelValue"])
        ]),
        C(Ce, {
          modelValue: d.value.phone,
          "onUpdate:modelValue": r[2] || (r[2] = (s) => d.value.phone = s)
        }, null, 8, ["modelValue"]),
        C(Ee, {
          modelValue: d.value.birthday,
          "onUpdate:modelValue": r[3] || (r[3] = (s) => d.value.birthday = s)
        }, null, 8, ["modelValue"]),
        C(H, {
          onClick: m,
          disabled: w.value,
          textContent: a(w.value ? "Saving..." : "Save")
        }, null, 8, ["disabled", "textContent"])
      ], 64)) : _("", !0)
    ], 512));
  }
}, is = /* @__PURE__ */ E(os, [["__scopeId", "data-v-7c315200"]]), us = {
  ref: "container",
  class: "offset-account-shipping"
}, rs = { class: "grouped" }, ds = { class: "grouped offset-account-form-actions" }, cs = {
  key: 2,
  class: "offset-account-card-grid"
}, fs = { class: "offset-account-card-name" }, vs = {
  key: 0,
  class: "offset-account-pill is-filled"
}, ps = { class: "offset-account-card-actions" }, ys = ["onClick"], ms = ["onClick"], _s = {
  __name: "AccountShipping",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, {
      data: p,
      hasAddresses: k,
      isAnyAddressPending: g,
      createAddressMutation: y,
      updateAddressMutation: w,
      deleteAddressMutation: l
    } = xe(), f = O(!1), d = O(!1), m = O(!1), o = {
      first_name: "",
      last_name: "",
      phone: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      country: "US",
      businessName: ""
    }, c = O(F({}, o)), r = O({
      first_name: !1,
      last_name: !1,
      address: !1,
      city: !1,
      state: !1,
      zip: !1
    });
    function s() {
      f.value = !0, d.value = !1, c.value = F({}, o);
    }
    function u(G) {
      f.value = !1, d.value = !0, c.value = F(F({}, o), G);
    }
    function P() {
      f.value = !1, d.value = !1;
    }
    function V() {
      r.value.first_name = T(c.value.first_name), r.value.last_name = T(c.value.last_name), r.value.address = T(c.value.address), r.value.city = T(c.value.city), r.value.state = T(c.value.state), r.value.zip = T(c.value.zip);
    }
    function K() {
      return j(this, null, function* () {
        if (V(), !(T(c.value.first_name) || T(c.value.last_name) || T(c.value.address) || T(c.value.city) || T(c.value.state) || T(c.value.zip))) {
          m.value = !0;
          try {
            d.value ? yield w.mutateAsync(F({}, c.value)) : yield y.mutateAsync(X(F({}, c.value), { default: "1" })), f.value = !1, d.value = !1;
          } finally {
            m.value = !1;
          }
        }
      });
    }
    function Z(G) {
      return j(this, null, function* () {
        yield l.mutate(G);
      });
    }
    const Q = N("container");
    return z(() => {
      M(Q.value, v.inheritStyle);
    }), (G, x) => (t(), n("div", us, [
      x[14] || (x[14] = e("h2", null, "Addresses", -1)),
      x[15] || (x[15] = e("hr", { class: "offset-account-rule" }, null, -1)),
      i(g) ? (t(), D(Pe, {
        key: 0,
        label: "Loading Addresses"
      })) : !i(k) || f.value || d.value ? (t(), n(S, { key: 1 }, [
        e("div", rs, [
          C(W, {
            type: "text",
            label: "First Name",
            modelValue: c.value.first_name,
            "onUpdate:modelValue": x[0] || (x[0] = (A) => c.value.first_name = A),
            required: "",
            floating: !0,
            invalid: r.value.first_name
          }, null, 8, ["modelValue", "invalid"]),
          C(W, {
            type: "text",
            label: "Last Name",
            modelValue: c.value.last_name,
            "onUpdate:modelValue": x[1] || (x[1] = (A) => c.value.last_name = A),
            required: "",
            floating: !0,
            invalid: r.value.last_name
          }, null, 8, ["modelValue", "invalid"])
        ]),
        C(Ce, {
          modelValue: c.value.phone,
          "onUpdate:modelValue": x[2] || (x[2] = (A) => c.value.phone = A)
        }, null, 8, ["modelValue"]),
        C(Ve, {
          address: c.value.address,
          "onUpdate:address": x[3] || (x[3] = (A) => c.value.address = A),
          address2: c.value.address2,
          "onUpdate:address2": x[4] || (x[4] = (A) => c.value.address2 = A),
          city: c.value.city,
          "onUpdate:city": x[5] || (x[5] = (A) => c.value.city = A),
          state: c.value.state,
          "onUpdate:state": x[6] || (x[6] = (A) => c.value.state = A),
          zip: c.value.zip,
          "onUpdate:zip": x[7] || (x[7] = (A) => c.value.zip = A),
          country: c.value.country,
          "onUpdate:country": x[8] || (x[8] = (A) => c.value.country = A),
          company: c.value.businessName,
          "onUpdate:company": x[9] || (x[9] = (A) => c.value.businessName = A),
          invalidAddress: r.value.address,
          invalidCity: r.value.city,
          invalidState: r.value.state,
          invalidZip: r.value.zip
        }, null, 8, ["address", "address2", "city", "state", "zip", "country", "company", "invalidAddress", "invalidCity", "invalidState", "invalidZip"]),
        e("div", ds, [
          C(H, {
            onClick: K,
            disabled: m.value
          }, {
            default: R(() => x[10] || (x[10] = [
              $("Save", -1)
            ])),
            _: 1,
            __: [10]
          }, 8, ["disabled"]),
          i(k) ? (t(), D(H, {
            key: 0,
            onClick: P,
            variant: "alt",
            disabled: m.value
          }, {
            default: R(() => x[11] || (x[11] = [
              $(" Cancel ", -1)
            ])),
            _: 1,
            __: [11]
          }, 8, ["disabled"])) : _("", !0)
        ])
      ], 64)) : (t(), n("div", cs, [
        (t(!0), n(S, null, q(i(p), (A) => (t(), n("div", {
          key: A.id,
          class: "offset-account-card"
        }, [
          e("strong", fs, a(A.first_name) + " " + a(A.last_name), 1),
          e("address", null, [
            $(a(A.address), 1),
            x[13] || (x[13] = e("br", null, null, -1)),
            A.address2 ? (t(), n(S, { key: 0 }, [
              $(a(A.address2), 1),
              x[12] || (x[12] = e("br", null, null, -1))
            ], 64)) : _("", !0),
            $(" " + a(A.city) + ", " + a(A.state) + " " + a(A.zip), 1)
          ]),
          A.default == "1" ? (t(), n("span", vs, " Default ")) : _("", !0),
          e("div", ps, [
            e("button", {
              type: "button",
              onClick: (b) => u(A)
            }, "Edit", 8, ys),
            e("button", {
              type: "button",
              onClick: (b) => Z(A.id)
            }, "Remove", 8, ms)
          ])
        ]))), 128)),
        e("button", {
          type: "button",
          class: "offset-account-card offset-account-card-add",
          onClick: s
        }, " Add an Address ")
      ]))
    ], 512));
  }
}, gs = /* @__PURE__ */ E(_s, [["__scopeId", "data-v-bfd207a2"]]), hs = {
  ref: "container",
  class: "offset-account-billing"
}, bs = {
  key: 0,
  class: "offset-account-error",
  role: "alert"
}, ks = { class: "offset-account-use-shipping" }, Ss = { class: "grouped" }, $s = { class: "grouped offset-account-form-actions" }, ws = {
  key: 3,
  class: "offset-account-card-grid"
}, As = { class: "offset-account-card-payment-info" }, Us = { class: "offset-account-card-meta" }, Ps = {
  key: 0,
  class: "offset-account-pill is-filled"
}, Cs = { class: "offset-account-card-actions" }, xs = ["onClick"], Vs = ["onClick"], Os = {
  __name: "AccountBilling",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, {
      data: p,
      isPending: k,
      hasPayments: g,
      updatePaymentMutation: y,
      deletePaymentMutation: w
    } = Me(), { selectedAddress: l } = xe(), { data: f } = B(), d = O(!1), m = O(!1), o = O(null), c = O(null), r = O(!0), s = O({
      first_name: "",
      last_name: "",
      address: "",
      address_2: "",
      city: "",
      state: "",
      zip: "",
      country: "US",
      businessName: ""
    }), u = O({
      first_name: !1,
      last_name: !1,
      address: !1,
      city: !1,
      state: !1,
      zip: !1
    }), P = I(() => c.value !== null && Fe(c.value) === null);
    function V() {
      u.value.first_name = T(s.value.first_name), u.value.last_name = T(s.value.last_name), u.value.address = T(s.value.address), u.value.city = T(s.value.city), u.value.state = T(s.value.state), u.value.zip = T(s.value.zip);
    }
    function K() {
      return j(this, null, function* () {
        var b, U, te;
        o.value = null;
        let A = s.value;
        if (r.value && l.value)
          A = {
            first_name: l.value.first_name,
            last_name: l.value.last_name,
            address: l.value.address,
            address_2: l.value.address_2,
            city: l.value.city,
            state: l.value.state,
            zip: l.value.zip,
            country: l.value.country,
            businessName: l.value.businessName
          };
        else if (V(), T(s.value.first_name) || T(s.value.last_name) || T(s.value.address) || T(s.value.city) || T(s.value.state) || T(s.value.zip))
          return;
        m.value = !0;
        try {
          yield Le(X(F({}, A), {
            email: ((b = l.value) == null ? void 0 : b.email) || ((U = f.value) == null ? void 0 : U.email),
            phone: (te = l.value) == null ? void 0 : te.phone
          })), d.value = !1;
        } catch (oe) {
          o.value = oe.message || oe;
        } finally {
          m.value = !1;
        }
      });
    }
    function Z() {
      d.value = !1, o.value = null;
    }
    function Q(A) {
      y.mutate(X(F({}, A), { default: "1" }));
    }
    function G(A) {
      w.mutate(A);
    }
    const x = N("container");
    return z(() => {
      M(x.value, v.inheritStyle);
    }), (A, b) => (t(), n("div", hs, [
      b[17] || (b[17] = e("h2", null, "Payment", -1)),
      b[18] || (b[18] = e("hr", { class: "offset-account-rule" }, null, -1)),
      o.value ? (t(), n("div", bs, a(o.value), 1)) : _("", !0),
      i(k) ? (t(), D(Pe, {
        key: 1,
        label: "Loading Payments"
      })) : !i(g) || d.value ? (t(), n(S, { key: 2 }, [
        b[16] || (b[16] = e("em", null, "All transactions are secure and encrypted.", -1)),
        C(Ye, {
          onPaymentTypeChanged: b[0] || (b[0] = (U) => c.value = U)
        }),
        e("label", ks, [
          C(Ue, {
            modelValue: r.value,
            "onUpdate:modelValue": b[1] || (b[1] = (U) => r.value = U)
          }, null, 8, ["modelValue"]),
          b[12] || (b[12] = $(" Use shipping address as billing address ", -1))
        ]),
        r.value ? _("", !0) : (t(), n(S, { key: 0 }, [
          b[13] || (b[13] = e("h3", null, "Billing Address", -1)),
          e("div", Ss, [
            C(W, {
              type: "text",
              label: "First Name",
              modelValue: s.value.first_name,
              "onUpdate:modelValue": b[2] || (b[2] = (U) => s.value.first_name = U),
              required: "",
              floating: !0,
              invalid: u.value.first_name
            }, null, 8, ["modelValue", "invalid"]),
            C(W, {
              type: "text",
              label: "Last Name",
              modelValue: s.value.last_name,
              "onUpdate:modelValue": b[3] || (b[3] = (U) => s.value.last_name = U),
              required: "",
              floating: !0,
              invalid: u.value.last_name
            }, null, 8, ["modelValue", "invalid"])
          ]),
          C(Ve, {
            address: s.value.address,
            "onUpdate:address": b[4] || (b[4] = (U) => s.value.address = U),
            address2: s.value.address_2,
            "onUpdate:address2": b[5] || (b[5] = (U) => s.value.address_2 = U),
            city: s.value.city,
            "onUpdate:city": b[6] || (b[6] = (U) => s.value.city = U),
            state: s.value.state,
            "onUpdate:state": b[7] || (b[7] = (U) => s.value.state = U),
            zip: s.value.zip,
            "onUpdate:zip": b[8] || (b[8] = (U) => s.value.zip = U),
            country: s.value.country,
            "onUpdate:country": b[9] || (b[9] = (U) => s.value.country = U),
            company: s.value.businessName,
            "onUpdate:company": b[10] || (b[10] = (U) => s.value.businessName = U),
            invalidAddress: u.value.address,
            invalidCity: u.value.city,
            invalidState: u.value.state,
            invalidZip: u.value.zip
          }, null, 8, ["address", "address2", "city", "state", "zip", "country", "company", "invalidAddress", "invalidCity", "invalidState", "invalidZip"])
        ], 64)),
        e("div", $s, [
          P.value ? (t(), D(H, {
            key: 0,
            onClick: re(K, ["stop"]),
            disabled: m.value
          }, {
            default: R(() => b[14] || (b[14] = [
              $(" Save ", -1)
            ])),
            _: 1,
            __: [14]
          }, 8, ["disabled"])) : _("", !0),
          i(g) ? (t(), D(H, {
            key: 1,
            onClick: re(Z, ["stop"]),
            variant: "alt",
            disabled: m.value
          }, {
            default: R(() => b[15] || (b[15] = [
              $(" Cancel ", -1)
            ])),
            _: 1,
            __: [15]
          }, 8, ["disabled"])) : _("", !0)
        ])
      ], 64)) : (t(), n("div", ws, [
        (t(!0), n(S, null, q(i(p), (U) => (t(), n("div", {
          key: U.id,
          class: "offset-account-card"
        }, [
          e("div", As, [
            C(He, {
              name: i(Be)(U.credit_type)
            }, null, 8, ["name"]),
            e("strong", null, a(U.credit_type) + " ending in " + a(U.credit_number), 1)
          ]),
          e("span", Us, " Expires " + a(U.credit_expires_month) + "/" + a(U.credit_expires_year), 1),
          U.default == "1" ? (t(), n("span", Ps, "Default")) : _("", !0),
          e("div", Cs, [
            U.default != "1" ? (t(), n("button", {
              key: 0,
              type: "button",
              onClick: (te) => Q(U)
            }, " Set as Default ", 8, xs)) : _("", !0),
            e("button", {
              type: "button",
              onClick: (te) => G(U.id)
            }, "Remove", 8, Vs)
          ])
        ]))), 128)),
        e("button", {
          type: "button",
          class: "offset-account-card offset-account-card-add",
          onClick: b[11] || (b[11] = (U) => d.value = !0)
        }, " Add a Card ")
      ])),
      b[19] || (b[19] = e("p", { class: "offset-account-billing-security" }, [
        e("strong", null, "Payments are powered and secured by Stripe."),
        e("br"),
        $(" All payment methods are securely stored at Stripe using bank-grade encryption. ")
      ], -1))
    ], 512));
  }
}, Ts = /* @__PURE__ */ E(Os, [["__scopeId", "data-v-56c24e5a"]]), Ds = { ref: "container" }, qs = {
  key: 0,
  class: "offset-account-success",
  role: "status"
}, Is = {
  key: 1,
  class: "offset-account-error",
  role: "alert"
}, Rs = {
  key: 2,
  class: "offset-account-error",
  role: "alert"
}, Ns = {
  __name: "AccountPassword",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, { isValidUser: p, updatePassword: k } = B(), g = O(""), y = O(""), w = O(!1), l = O(!1), f = O(null), d = O(!1);
    function m() {
      return j(this, null, function* () {
        if (d.value = !1, f.value = null, g.value !== y.value) {
          d.value = !0;
          return;
        }
        if (g.value.length < 8) {
          f.value = "Password must be at least 8 characters.";
          return;
        }
        w.value = !0, l.value = !1;
        try {
          yield k({
            password: g.value,
            confirm_password: y.value
          }), l.value = !0, g.value = "", y.value = "";
        } catch (c) {
          f.value = c.message;
        } finally {
          w.value = !1;
        }
      });
    }
    const o = N("container");
    return z(() => {
      M(o.value, v.inheritStyle);
    }), (c, r) => (t(), n("div", Ds, [
      r[2] || (r[2] = e("h2", null, "Password", -1)),
      r[3] || (r[3] = e("hr", { class: "offset-account-rule" }, null, -1)),
      l.value ? (t(), n("div", qs, "Password updated successfully.")) : _("", !0),
      d.value ? (t(), n("div", Is, "Passwords do not match.")) : _("", !0),
      f.value ? (t(), n("div", Rs, a(f.value), 1)) : _("", !0),
      i(p) ? (t(), n(S, { key: 3 }, [
        C(W, {
          type: "password",
          label: "New Password",
          modelValue: g.value,
          "onUpdate:modelValue": r[0] || (r[0] = (s) => g.value = s),
          required: "",
          floating: !0
        }, null, 8, ["modelValue"]),
        C(W, {
          type: "password",
          label: "Confirm Password",
          modelValue: y.value,
          "onUpdate:modelValue": r[1] || (r[1] = (s) => y.value = s),
          required: "",
          floating: !0
        }, null, 8, ["modelValue"]),
        C(H, {
          onClick: m,
          disabled: w.value,
          textContent: a(w.value ? "Saving..." : "Update Password")
        }, null, 8, ["disabled", "textContent"])
      ], 64)) : _("", !0)
    ], 512));
  }
}, zs = /* @__PURE__ */ E(Ns, [["__scopeId", "data-v-5ba0aa9d"]]), Ms = {
  ref: "container",
  class: "offset-account-details"
}, Es = { class: "offset-account-details-layout" }, Fs = { class: "offset-account-details-nav" }, Ys = ["onClick"], Ls = { class: "offset-account-details-content" }, Bs = {
  "data-section": "account",
  class: "offset-account-details-section"
}, Hs = {
  "data-section": "addresses",
  class: "offset-account-details-section"
}, js = {
  "data-section": "payment",
  class: "offset-account-details-section"
}, Ws = {
  "data-section": "password",
  class: "offset-account-details-section"
}, Qs = {
  __name: "AccountDetails",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, p = [
      { key: "account", label: "Account" },
      { key: "addresses", label: "Addresses" },
      { key: "payment", label: "Payment" },
      { key: "password", label: "Password" }
    ], k = O(p[0].key), g = N("container");
    let y = null;
    function w(l) {
      var f, d;
      k.value = l, (d = (f = g.value) == null ? void 0 : f.querySelector(`[data-section="${l}"]`)) == null || d.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return z(() => {
      var l;
      M(g.value, v.inheritStyle), y = new IntersectionObserver(
        (f) => {
          const d = f.filter((m) => m.isIntersecting);
          d.length && (k.value = d[0].target.dataset.section);
        },
        { rootMargin: "-10% 0px -70% 0px" }
      ), (l = g.value) == null || l.querySelectorAll("[data-section]").forEach((f) => y.observe(f));
    }), $e(() => {
      y == null || y.disconnect();
    }), (l, f) => (t(), n("div", Ms, [
      f[0] || (f[0] = e("h2", null, "Details", -1)),
      e("div", Es, [
        e("nav", Fs, [
          (t(), n(S, null, q(p, (d) => e("button", {
            key: d.key,
            type: "button",
            class: ae({ active: k.value === d.key }),
            onClick: (m) => w(d.key)
          }, a(d.label), 11, Ys)), 64))
        ]),
        e("div", Ls, [
          e("section", Bs, [
            C(is, {
              inheritStyle: v.inheritStyle
            }, null, 8, ["inheritStyle"])
          ]),
          e("section", Hs, [
            C(gs, {
              inheritStyle: v.inheritStyle
            }, null, 8, ["inheritStyle"])
          ]),
          e("section", js, [
            C(Ts, {
              inheritStyle: v.inheritStyle
            }, null, 8, ["inheritStyle"])
          ]),
          e("section", Ws, [
            C(zs, {
              inheritStyle: v.inheritStyle
            }, null, 8, ["inheritStyle"])
          ])
        ])
      ])
    ], 512));
  }
}, Ks = /* @__PURE__ */ E(Qs, [["__scopeId", "data-v-d4ed7757"]]), Zs = {
  ref: "container",
  class: "offset-account-membership"
}, Gs = { class: "offset-account-offer-meta" }, Js = {
  key: 0,
  class: "offset-account-offer-date"
}, Xs = { key: 0 }, en = { key: 1 }, tn = ["href"], sn = {
  key: 2,
  class: "offset-account-membership-cancel-note"
}, nn = {
  __name: "AccountMembership",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(h) {
    const v = h, { data: p, isPending: k } = B(), { config: g } = se(), y = N("container");
    return z(() => {
      M(y.value, v.inheritStyle);
    }), (w, l) => {
      var f;
      return t(), n("div", Zs, [
        e("h2", null, a(i(g).club_title || "Membership"), 1),
        i(k) ? (t(), D(J, { key: 0 })) : !((f = i(p)) != null && f.clubs) || i(p).clubs.length === 0 ? (t(), n(S, { key: 1 }, [
          l[1] || (l[1] = e("hr", { class: "offset-account-rule" }, null, -1)),
          l[2] || (l[2] = e("p", null, "You are not currently a member.", -1)),
          i(g).enable_membership_opt_in_account ? (t(), D(ee, {
            key: 0,
            href: "/membership"
          }, {
            default: R(() => l[0] || (l[0] = [
              $(" Join Today ", -1)
            ])),
            _: 1,
            __: [0]
          })) : _("", !0)
        ], 64)) : (t(), n(S, { key: 2 }, [
          l[4] || (l[4] = e("hr", { class: "offset-account-rule" }, null, -1)),
          (t(!0), n(S, null, q(i(p).clubs, (d) => (t(), n("section", {
            key: d.club_id || d.id,
            class: "offset-account-offer"
          }, [
            e("div", Gs, [
              l[3] || (l[3] = e("span", { class: "offset-account-pill is-filled" }, "Membership", -1)),
              d.created ? (t(), n("span", Js, " Member since " + a(i(L)(d.created)), 1)) : _("", !0)
            ]),
            e("h3", null, a(d.name), 1),
            e("p", null, " To manage your " + a(i(g).club_title || "membership") + " shipping and billing, or for any help, please contact us. ", 1),
            i(g).company_phone ? (t(), n("p", Xs, "Phone: " + a(i(g).company_phone), 1)) : _("", !0),
            i(g).company_email ? (t(), n("p", en, [
              e("a", {
                href: `mailto:${i(g).company_email}`
              }, a(i(g).company_email), 9, tn)
            ])) : _("", !0),
            i(g).enable_membership_opt_out ? (t(), n("p", sn, " To cancel your " + a(i(g).club_title || "membership") + ", please contact us. ", 1)) : _("", !0)
          ]))), 128))
        ], 64))
      ], 512);
    };
  }
}, an = /* @__PURE__ */ E(nn, [["__scopeId", "data-v-5422b6ef"]]);
function ln() {
  ne();
  const { isValidUser: h } = B(), v = Ae({
    queryKey: ["appointments", h],
    queryFn: () => j(null, null, function* () {
      if (!h.value) return [];
      const p = yield ke("appointments");
      return !p || p.error ? [] : Array.isArray(p) ? p : Object.values(p);
    })
  });
  return F({}, v);
}
const on = { ref: "container" }, un = { key: 0 }, rn = { key: 1 }, dn = ["href"], cn = ["href"], fn = { class: "offset-account-appointment-header" }, vn = { class: "offset-account-appointment-body" }, pn = { key: 0 }, yn = { key: 1 }, mn = { key: 2 }, _n = {
  __name: "AccountAppointments",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    visitUrl: {
      type: String,
      default: "/visit"
    }
  },
  setup(h) {
    const v = h, { data: p, isPending: k } = ln(), { data: g } = B(), { config: y } = se(), w = ["Declined", "No Show", "Cancelled"], l = I(() => p.value ? p.value.filter((o) => !w.includes(o.status)) : []), f = I(() => l.value.length > 0);
    function d(o) {
      return o === "Confirmed" ? "is-success" : o === "Requested" ? "is-warning" : "is-secondary";
    }
    const m = N("container");
    return z(() => {
      M(m.value, v.inheritStyle);
    }), (o, c) => {
      var r, s;
      return t(), n("div", on, [
        c[2] || (c[2] = e("h2", null, "Appointments", -1)),
        i(k) ? (t(), D(J, { key: 0 })) : (t(), n(S, { key: 1 }, [
          f.value ? (t(), n("p", rn, [
            $(" Thank you, " + a((s = i(g)) == null ? void 0 : s.first_name) + ". For any questions ", 1),
            i(y).company_phone ? (t(), n(S, { key: 0 }, [
              $(" call " + a(i(y).company_phone) + " or ", 1)
            ], 64)) : _("", !0),
            c[0] || (c[0] = $(" email ", -1)),
            e("a", {
              href: `mailto:${i(y).company_email}`
            }, a(i(y).company_email), 9, dn),
            c[1] || (c[1] = $(". ", -1))
          ])) : (t(), n("p", un, a((r = i(g)) == null ? void 0 : r.first_name) + ", it looks like you don't have any appointments yet. ", 1)),
          e("a", {
            href: v.visitUrl,
            class: "offset-account-visit-link"
          }, "Request a Visit", 8, cn),
          (t(!0), n(S, null, q(l.value, (u) => (t(), n("div", {
            key: u.id,
            class: "offset-account-appointment"
          }, [
            e("div", fn, [
              e("span", {
                class: ae(["offset-badge", d(u.status)])
              }, a(u.status), 3),
              e("strong", null, "#" + a(u.id), 1),
              e("span", null, a(u.type), 1)
            ]),
            e("div", vn, [
              u.status === "Requested" ? (t(), n("p", pn, [
                $(" Requested: " + a(i(L)(u.timestamp)) + " ", 1),
                u.alternate_date ? (t(), n(S, { key: 0 }, [
                  $(" or " + a(i(L)(u.alternate_date)), 1)
                ], 64)) : _("", !0)
              ])) : (t(), n("p", yn, a(i(L)(u.timestamp)), 1)),
              e("p", null, a(u.size) + " guests", 1),
              u.status === "Requested" ? (t(), n("em", mn, " Please allow up to 2-3 business days for us to respond to this request. ")) : _("", !0)
            ])
          ]))), 128))
        ], 64))
      ], 512);
    };
  }
}, gn = /* @__PURE__ */ E(_n, [["__scopeId", "data-v-0b844653"]]), hn = { ref: "container" }, bn = {
  key: 0,
  class: "offset-account-success",
  role: "status"
}, kn = {
  key: 1,
  class: "offset-account-error",
  role: "alert"
}, Sn = { class: "offset-account-radio-group" }, $n = { class: "offset-account-muted" };
var ve, pe, ye, me;
const wn = {
  __name: "AccountTextMessages",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    termsUrl: {
      type: String,
      default: (pe = (ve = window.OFFSET) == null ? void 0 : ve.termsUrl) != null ? pe : "/terms"
    },
    privacyUrl: {
      type: String,
      default: (me = (ye = window.OFFSET) == null ? void 0 : ye.privacyUrl) != null ? me : "/privacy"
    }
  },
  setup(h) {
    const v = h, { data: p, isValidUser: k, updateProfile: g } = B(), y = ne(), w = O("No"), l = O(""), f = O(!1), d = O(!1), m = O(null);
    Se(
      p,
      (r) => {
        r && (w.value = r.receive_text_messages || "No", l.value = r.mobile_phone || "");
      },
      { immediate: !0 }
    );
    function o() {
      return j(this, null, function* () {
        f.value = !0, d.value = !1, m.value = null;
        try {
          yield g({
            receive_text_messages: w.value,
            mobile_phone: l.value
          }), y == null || y.invalidateQueries({ queryKey: ["user"] }), d.value = !0;
        } catch (r) {
          m.value = r.message;
        } finally {
          f.value = !1;
        }
      });
    }
    const c = N("container");
    return z(() => {
      M(c.value, v.inheritStyle);
    }), (r, s) => (t(), n("div", hn, [
      s[10] || (s[10] = e("h2", null, "Text Messaging", -1)),
      s[11] || (s[11] = e("p", null, " Opt in with a valid mobile phone number to receive text message notifications of offering reminders and updates. ", -1)),
      d.value ? (t(), n("div", bn, "Preferences updated.")) : _("", !0),
      m.value ? (t(), n("div", kn, a(m.value), 1)) : _("", !0),
      i(k) ? (t(), n(S, { key: 2 }, [
        C(W, {
          type: "tel",
          label: "Mobile Phone",
          modelValue: l.value,
          "onUpdate:modelValue": s[0] || (s[0] = (u) => l.value = u),
          floating: !0
        }, null, 8, ["modelValue"]),
        e("div", Sn, [
          e("label", null, [
            de(e("input", {
              type: "radio",
              value: "Yes",
              "onUpdate:modelValue": s[1] || (s[1] = (u) => w.value = u)
            }, null, 512), [
              [ce, w.value]
            ]),
            s[3] || (s[3] = $(" Yes, send me text messages. ", -1))
          ]),
          e("label", null, [
            de(e("input", {
              type: "radio",
              value: "No",
              "onUpdate:modelValue": s[2] || (s[2] = (u) => w.value = u)
            }, null, 512), [
              [ce, w.value]
            ]),
            s[4] || (s[4] = $(" No, do not send me text messages. ", -1))
          ])
        ]),
        C(H, {
          onClick: o,
          disabled: f.value,
          textContent: a(f.value ? "Saving..." : "Update")
        }, null, 8, ["disabled", "textContent"])
      ], 64)) : _("", !0),
      s[12] || (s[12] = e("p", { class: "offset-account-muted" }, " Text messaging preferences can be updated at any time. You can also reply STOP to cancel or HELP for help. Message & Data rates may apply. ", -1)),
      e("p", $n, [
        s[7] || (s[7] = $(" View our ", -1)),
        C(ee, {
          href: v.termsUrl
        }, {
          default: R(() => s[5] || (s[5] = [
            $("Terms & Conditions", -1)
          ])),
          _: 1,
          __: [5]
        }, 8, ["href"]),
        s[8] || (s[8] = $(" and ", -1)),
        C(ee, {
          href: v.privacyUrl
        }, {
          default: R(() => s[6] || (s[6] = [
            $("Privacy Policy", -1)
          ])),
          _: 1,
          __: [6]
        }, 8, ["href"]),
        s[9] || (s[9] = $(" to understand how we use your data. ", -1))
      ])
    ], 512));
  }
}, An = /* @__PURE__ */ E(wn, [["__scopeId", "data-v-b5a8f0cd"]]), Un = {
  ref: "container",
  class: "offset-account"
}, Pn = {
  key: 0,
  class: "offset-account-topbar"
}, Cn = { class: "offset-account-topbar-user" }, xn = {
  class: "offset-account-tabs",
  role: "tablist"
}, Vn = ["aria-selected", "onClick"], On = ["value"], Tn = ["value"], Dn = {
  class: "offset-account-main",
  ref: "main",
  tabindex: "-1"
};
var _e, ge, he, be;
const qn = {
  __name: "Account",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    initialPage: {
      type: String,
      default: "home"
    },
    termsUrl: {
      type: String,
      default: (ge = (_e = window.OFFSET) == null ? void 0 : _e.termsUrl) != null ? ge : "/terms"
    },
    privacyUrl: {
      type: String,
      default: (be = (he = window.OFFSET) == null ? void 0 : he.privacyUrl) != null ? be : "/privacy"
    },
    visitUrl: {
      type: String,
      default: "/visit"
    }
  },
  setup(h) {
    const v = h, { data: p, logoutMutation: k } = B(), { mutate: g } = k, { config: y } = se(), w = [
      "home",
      "offers",
      "membership",
      "wines",
      "history",
      "details",
      "appointments",
      "textmessages"
    ];
    function l() {
      const s = window.location.hash.slice(1);
      return w.includes(s) ? s : v.initialPage;
    }
    const f = O(l());
    function d(s) {
      f.value = s, window.location.hash = s, Re(() => {
        var u;
        return (u = r.value) == null ? void 0 : u.focus();
      });
    }
    function m() {
      f.value = l();
    }
    const o = I(() => {
      const s = [
        { key: "home", label: "Home" },
        { key: "offers", label: "Offers" }
      ];
      return y.value.enable_club_web && s.push({ key: "membership", label: y.value.club_title || "Membership" }), s.push(
        { key: "wines", label: "Your Wines" },
        { key: "history", label: "Your History" },
        { key: "details", label: "Details" }
      ), y.value.enable_appointments_web && s.push({ key: "appointments", label: "Appointments" }), y.value.enable_text_alerts && s.push({ key: "textmessages", label: "Text Messaging" }), s;
    }), c = N("container"), r = N("main");
    return z(() => {
      M(c.value, v.inheritStyle), window.addEventListener("hashchange", m);
    }), $e(() => {
      window.removeEventListener("hashchange", m);
    }), (s, u) => (t(), n("div", Un, [
      i(p) ? (t(), n("div", Pn, [
        e("span", Cn, a(i(p).first_name) + " " + a(i(p).last_name), 1),
        e("button", {
          class: "offset-account-signout",
          onClick: u[0] || (u[0] = (...P) => i(g) && i(g)(...P))
        }, "Sign Out")
      ])) : _("", !0),
      e("nav", xn, [
        (t(!0), n(S, null, q(o.value, (P) => (t(), n("button", {
          key: P.key,
          class: ae(["offset-account-tab", { active: f.value === P.key }]),
          role: "tab",
          "aria-selected": f.value === P.key,
          onClick: (V) => d(P.key)
        }, a(P.label), 11, Vn))), 128))
      ]),
      e("select", {
        class: "offset-account-nav-mobile",
        value: f.value,
        onChange: u[1] || (u[1] = (P) => P.target.value === "__logout__" ? i(g)() : d(P.target.value))
      }, [
        (t(!0), n(S, null, q(o.value, (P) => (t(), n("option", {
          key: P.key,
          value: P.key
        }, a(P.label), 9, Tn))), 128)),
        u[2] || (u[2] = e("option", { disabled: "" }, "──────────", -1)),
        u[3] || (u[3] = e("option", { value: "__logout__" }, "Log Out", -1))
      ], 40, On),
      e("main", Dn, [
        f.value === "home" ? (t(), D(tt, {
          key: 0,
          inheritStyle: v.inheritStyle,
          onNavigate: d
        }, null, 8, ["inheritStyle"])) : f.value === "offers" ? (t(), D(ft, {
          key: 1,
          inheritStyle: v.inheritStyle
        }, null, 8, ["inheritStyle"])) : f.value === "membership" ? (t(), D(an, {
          key: 2,
          inheritStyle: v.inheritStyle
        }, null, 8, ["inheritStyle"])) : f.value === "wines" ? (t(), D(Tt, {
          key: 3,
          inheritStyle: v.inheritStyle
        }, null, 8, ["inheritStyle"])) : f.value === "history" ? (t(), D(ts, {
          key: 4,
          inheritStyle: v.inheritStyle
        }, null, 8, ["inheritStyle"])) : f.value === "details" ? (t(), D(Ks, {
          key: 5,
          inheritStyle: v.inheritStyle
        }, null, 8, ["inheritStyle"])) : f.value === "appointments" ? (t(), D(gn, {
          key: 6,
          inheritStyle: v.inheritStyle,
          visitUrl: v.visitUrl
        }, null, 8, ["inheritStyle", "visitUrl"])) : f.value === "textmessages" ? (t(), D(An, {
          key: 7,
          inheritStyle: v.inheritStyle,
          termsUrl: v.termsUrl,
          privacyUrl: v.privacyUrl
        }, null, 8, ["inheritStyle", "termsUrl", "privacyUrl"])) : _("", !0)
      ], 512)
    ], 512));
  }
}, na = /* @__PURE__ */ E(qn, [["__scopeId", "data-v-cf7ee1c3"]]);
export {
  na as A
};
